import axios from "./axios-base"

var endpoint = {
    // ログイン
    login: "/login",
    // ログアウト
    logout: "/logout",
    // 実行予算履歴
    budget_history: "/budget/history",
    // 実行予算最新情報
    budget_latest: "/budget/latest",
    // 実行予算情報
    budget: "/budget",
    // ユーザーマスタ
    user: "/user",
    // 利用規約マスタ
    user_policys: "/user_policys",
    // 顧客管理
    client: "/client",
    // 部署マスタ
    department: "/department",
    // 機材マスタ
    equipment: "/equipment",
    // 外注業者マスタ
    subcontractor: "/subcontractor",
    // 工事マスタ
    construction: "/construction",
    // 勘定科目マスタ
    account: "/account",
    // 費目マスタ
    expense: "/expense",
    // 費目マスタ非ボリ込み
    expense_refine: "/expense/refine",
    // カテゴリマスタ
    category: "/category",
    // 取引先マスタ
    suppliers: "/suppliers",
    // 費目テンプレート
    template: "/template",
    // 集計費目マスタ
    aggregate: "/aggregate",
    // 作業日報一覧
    worker_daily_report: "/report/daily/worker",
    worker_daily_report_sub: "/report/daily/worker_sub",
    // 作業日報一括修正
    worker_daily_report_bulk: "/report/daily/worker_bulk",
    // 作業日報(経費)一括修正
    worker_daily_report_expense_bulk: "/report/daily/worker_expense_bulk",
    // 工事情報絞り込み
    construction_refine: "/construction/refine",
    // 工事情報複製
    construction_copy: "/construction/copy",
    // 工事情部署報絞り込み
    construction_department: "/construction/department",
    // 作業日報確認一覧
    worker_daily_report_comform: "/report/daily/worker/comform",
    // 工事情報集計
    construction_aggregate: "/construction/aggregate",
    // 工事日報一覧
    construction_daily_report: "/report/daily/construction",
    // 工事日報一覧(全)
    construction_daily_report_all: "/report/daily/construction/all",
    // 権限情報
    permissions: "/permissions",
    // 実行予算書エクセルダウンロード
    budget_excel_download: "/budget/excel/download",
    // 工事日報エクセルダウンロード
    report_excel_download: "/report/excel/download",
    // 日毎作業日報確認書エクセルダウンロード
    date_every_excel_download: "/date/every/excel/download",
    // ユーザー毎作業日報確認書エクセルダウンロード
    person_every_excel_download: "/person/every/excel/download",
    // 等級マスタ
    rank: "/rank",
    // 分析情報
    analysis: "/analysis",
    // 実績情報
    achievement: "/achievement",
    // お知らせマスタ
    notifications: "/notifications",
    // 問い合わせ情報
    inquiries: "/inquiries",
    // システムお知らせマスタ
    system_notifications: "/system_notifications",

};
var delete_prefix = "/del";

export default {
    endpoint: endpoint,
    get: function({endpoint = "", id = null, params = {}}) {
        if (id) {
            endpoint = `${endpoint}/${id}`;
        }
        return axios.get(endpoint, params);
    },
    post: function({endpoint = "", id = null, params = {}}) {
        if (id) {
            endpoint = `${endpoint}/${id}`;
        }
        return axios.post(endpoint, params);
    },
    delete: function({endpoint = "", id = null, params = {}}) {
        if (id) {
            endpoint = `${endpoint}/${id}`;
        }
        // CDNがDELETEメソッドに対応していないためGETで行う
        // return axios.delete(endpoint, params);
        return axios.get(delete_prefix + endpoint, params);
    },
    link: {
        get: function({links = [], params = {}}) {
            var endpoint = "";
            for (var link of links) {
                endpoint += `${link.endpoint}`;
                if (link.id) {
                    endpoint += `/${link.id}`
                }
            }
            return axios.get(endpoint, params);
        },
        post: function({links = [], params = {}}) {
            var endpoint = "";
            for (var link of links) {
                endpoint += `${link.endpoint}`;
                if (link.id) {
                    endpoint += `/${link.id}`
                }
            }
            return axios.post(endpoint, params);
        },
        delete: function({links = [], params = {}}) {
            var endpoint = "";
            for (var link of links) {
                endpoint += `${link.endpoint}`;
                if (link.id) {
                    endpoint += `/${link.id}`
                }
            }
            // CDNがDELETEメソッドに対応していないためGETで行う
            // return axios.delete(endpoint, params);
            return axios.get(delete_prefix + endpoint, params);
        },
    }
};
